declare namespace $ {

	type $mol_hotkey__key_bog_gamengine_studio_1 = $mol_type_enforce<
		({ 
			escape( next?: ReturnType< $bog_gamengine_studio['tool_drop'] > ): ReturnType< $bog_gamengine_studio['tool_drop'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $mol_hotkey__key_bog_gamengine_studio_2 = $mol_type_enforce<
		({ 
			delete( next?: ReturnType< $bog_gamengine_studio['key_drop'] > ): ReturnType< $bog_gamengine_studio['key_drop'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $mol_hotkey__mod_ctrl_bog_gamengine_studio_3 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_hotkey['mod_ctrl'] >
	>
	type $mol_hotkey__key_bog_gamengine_studio_4 = $mol_type_enforce<
		({ 
			Z( next?: ReturnType< $bog_gamengine_studio['key_undo'] > ): ReturnType< $bog_gamengine_studio['key_undo'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $mol_hotkey__mod_ctrl_bog_gamengine_studio_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_hotkey['mod_ctrl'] >
	>
	type $mol_hotkey__mod_shift_bog_gamengine_studio_6 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_hotkey['mod_shift'] >
	>
	type $mol_hotkey__key_bog_gamengine_studio_7 = $mol_type_enforce<
		({ 
			Z( next?: ReturnType< $bog_gamengine_studio['key_redo'] > ): ReturnType< $bog_gamengine_studio['key_redo'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $mol_switch__value_bog_gamengine_studio_8 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['tab'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_gamengine_studio_9 = $mol_type_enforce<
		({ 
			'0': string,
			'1': string,
			'2': string,
			'3': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_list__rows_bog_gamengine_studio_10 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['node_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_scroll__title_bog_gamengine_studio_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_scroll['title'] >
	>
	type $mol_scroll__attr_bog_gamengine_studio_12 = $mol_type_enforce<
		({ 
			'hidden': ReturnType< $bog_gamengine_studio['tab_hidden_0'] >,
		})  & ReturnType< $mol_scroll['attr'] >
		,
		ReturnType< $mol_scroll['attr'] >
	>
	type $mol_scroll__sub_bog_gamengine_studio_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_list__rows_bog_gamengine_studio_14 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['asset_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_scroll__title_bog_gamengine_studio_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_scroll['title'] >
	>
	type $mol_scroll__attr_bog_gamengine_studio_16 = $mol_type_enforce<
		({ 
			'hidden': ReturnType< $bog_gamengine_studio['tab_hidden_1'] >,
		})  & ReturnType< $mol_scroll['attr'] >
		,
		ReturnType< $mol_scroll['attr'] >
	>
	type $mol_scroll__sub_bog_gamengine_studio_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_list__rows_bog_gamengine_studio_18 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['tile_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_scroll__title_bog_gamengine_studio_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_scroll['title'] >
	>
	type $mol_scroll__attr_bog_gamengine_studio_20 = $mol_type_enforce<
		({ 
			'hidden': ReturnType< $bog_gamengine_studio['tab_hidden_2'] >,
		})  & ReturnType< $mol_scroll['attr'] >
		,
		ReturnType< $mol_scroll['attr'] >
	>
	type $mol_scroll__sub_bog_gamengine_studio_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_list__rows_bog_gamengine_studio_22 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['kit_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_scroll__title_bog_gamengine_studio_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_scroll['title'] >
	>
	type $mol_scroll__attr_bog_gamengine_studio_24 = $mol_type_enforce<
		({ 
			'hidden': ReturnType< $bog_gamengine_studio['tab_hidden_3'] >,
		})  & ReturnType< $mol_scroll['attr'] >
		,
		ReturnType< $mol_scroll['attr'] >
	>
	type $mol_scroll__sub_bog_gamengine_studio_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_view__sub_bog_gamengine_studio_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_bog_gamengine_studio_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_studio_28 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['grid'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_30 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['can_undo'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_31 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['undo'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_33 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['can_redo'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_34 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['redo'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_36 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['fit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_38 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_39 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['play'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_box__title_bog_gamengine_studio_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__enabled_bog_gamengine_studio_41 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['playing'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_check_box__checked_bog_gamengine_studio_42 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['paused'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_44 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['playing'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_45 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['stop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $bog_gamengine_draw__scene_bog_gamengine_studio_46 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_studio_47 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Cam'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $bog_gamengine_draw__event_bog_gamengine_studio_48 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gamengine_studio['pointer_down'] > ): ReturnType< $bog_gamengine_studio['pointer_down'] >,
			pointermove( next?: ReturnType< $bog_gamengine_studio['pointer_move'] > ): ReturnType< $bog_gamengine_studio['pointer_move'] >,
			pointerup( next?: ReturnType< $bog_gamengine_studio['pointer_up'] > ): ReturnType< $bog_gamengine_studio['pointer_up'] >,
			wheel( next?: ReturnType< $bog_gamengine_studio['wheel'] > ): ReturnType< $bog_gamengine_studio['wheel'] >,
		}) 
		,
		ReturnType< $bog_gamengine_draw['event'] >
	>
	type $mol_drop__attr_bog_gamengine_studio_49 = $mol_type_enforce<
		({ 
			'bog_gamengine_studio_placing': ReturnType< $bog_gamengine_studio['placing'] >,
		})  & ReturnType< $mol_drop['attr'] >
		,
		ReturnType< $mol_drop['attr'] >
	>
	type $mol_drop__drop_bog_gamengine_studio_50 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['asset_drop'] >
		,
		ReturnType< $mol_drop['drop'] >
	>
	type $mol_drop__Sub_bog_gamengine_studio_51 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Draw'] >
		,
		ReturnType< $mol_drop['Sub'] >
	>
	type $mol_status__status_bog_gamengine_studio_52 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['scene_status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_view__sub_bog_gamengine_studio_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_bog_gamengine_studio_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_gamengine_studio_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_gamengine_studio_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_gamengine_studio_57 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['canvas_foot'] >
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_58 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_59 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_60 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['detach'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_61 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_62 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_63 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['node_dup'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_64 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_65 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_66 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['node_drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_form__form_fields_bog_gamengine_studio_67 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['fields'] >
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__foot_bog_gamengine_studio_68 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['form_foot'] >
		,
		ReturnType< $mol_form['foot'] >
	>
	type $mol_page__title_bog_gamengine_studio_69 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_gamengine_studio_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__uri_bog_gamengine_studio_71 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['source_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__file_name_bog_gamengine_studio_72 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['file_name'] >
	>
	type $mol_link__title_bog_gamengine_studio_73 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_string__hint_bog_gamengine_studio_74 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gamengine_studio_75 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['klass'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_link__uri_bog_gamengine_studio_76 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['module_tree_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__file_name_bog_gamengine_studio_77 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['module_tree_name'] >
		,
		ReturnType< $mol_link['file_name'] >
	>
	type $mol_link__title_bog_gamengine_studio_78 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_gamengine_studio_79 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['module_ts_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__file_name_bog_gamengine_studio_80 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['module_ts_name'] >
		,
		ReturnType< $mol_link['file_name'] >
	>
	type $mol_link__title_bog_gamengine_studio_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_textarea__value_bog_gamengine_studio_82 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['source'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_view__sub_bog_gamengine_studio_83 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_studio_84 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_studio_85 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_bog_gamengine_studio_86 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_gamengine_studio_87 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_gamengine_studio_88 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_gamengine_studio_89 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $bog_gamengine_clock__paused_bog_gamengine_studio_90 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['clock_paused'] >
		,
		ReturnType< $bog_gamengine_clock['paused'] >
	>
	type $mol_view__sub_bog_gamengine_studio_91 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check__title_bog_gamengine_studio_92 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_gamengine_studio_93 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['armed'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_94 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_95 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_96 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['refs_clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check__Icon_bog_gamengine_studio_97 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['asset_icon'] >
		,
		ReturnType< $mol_check['Icon'] >
	>
	type $mol_check__title_bog_gamengine_studio_98 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['asset_file'] >
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_gamengine_studio_99 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['asset_selected'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_string__enabled_bog_gamengine_studio_100 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__hint_bog_gamengine_studio_101 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['node_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gamengine_studio_102 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['node_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $bog_gamengine_studio_doc__source_own_bog_gamengine_studio_103 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['source_own'] >
		,
		ReturnType< $bog_gamengine_studio_doc['source_own'] >
	>
	type $bog_gamengine_studio_doc__land_bog_gamengine_studio_104 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['doc_land'] >
		,
		ReturnType< $bog_gamengine_studio_doc['land'] >
	>
	type $bog_gamengine_studio_doc__input_bog_gamengine_studio_105 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['scene_input'] >
		,
		ReturnType< $bog_gamengine_studio_doc['input'] >
	>
	type $bog_gamengine_studio_doc__overlay_bog_gamengine_studio_106 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['overlay_batches'] >
		,
		ReturnType< $bog_gamengine_studio_doc['overlay'] >
	>
	type $bog_gamengine_studio_doc__clock_bog_gamengine_studio_107 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Clock'] >
		,
		ReturnType< $bog_gamengine_studio_doc['clock'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_studio_108 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Gizmo_shader'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__shape_bog_gamengine_studio_109 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Gizmo_arrow'] >
		,
		ReturnType< $bog_gamengine_batch['shape'] >
	>
	type $bog_gamengine_batch__nodes_bog_gamengine_studio_110 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_arrow_nodes'] >
		,
		ReturnType< $bog_gamengine_batch['nodes'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_studio_111 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Gizmo_shader'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__shape_bog_gamengine_studio_112 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Gizmo_box'] >
		,
		ReturnType< $bog_gamengine_batch['shape'] >
	>
	type $bog_gamengine_batch__nodes_bog_gamengine_studio_113 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_box_nodes'] >
		,
		ReturnType< $bog_gamengine_batch['nodes'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_studio_114 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Gizmo_shader'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__shape_bog_gamengine_studio_115 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Rect_shape'] >
		,
		ReturnType< $bog_gamengine_batch['shape'] >
	>
	type $bog_gamengine_batch__nodes_bog_gamengine_studio_116 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['rect_nodes'] >
		,
		ReturnType< $bog_gamengine_batch['nodes'] >
	>
	type $bog_gamengine_studio_doc_land__link_bog_gamengine_studio_117 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['land_link'] >
		,
		ReturnType< $bog_gamengine_studio_doc_land['link'] >
	>
	type $bog_gamengine_studio_doc_land__name_bog_gamengine_studio_118 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_name'] >
		,
		ReturnType< $bog_gamengine_studio_doc_land['name'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_studio_119 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Gizmo_shader'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__shape_bog_gamengine_studio_120 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Mate_shape'] >
		,
		ReturnType< $bog_gamengine_batch['shape'] >
	>
	type $bog_gamengine_batch__nodes_bog_gamengine_studio_121 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_nodes'] >
		,
		ReturnType< $bog_gamengine_batch['nodes'] >
	>
	type $bog_gamengine_node__pos_bog_gamengine_studio_122 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_pos'] >
		,
		ReturnType< $bog_gamengine_node['pos'] >
	>
	type $bog_gamengine_node__scale_bog_gamengine_studio_123 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_scale'] >
		,
		ReturnType< $bog_gamengine_node['scale'] >
	>
	type $bog_gamengine_node__tint_bog_gamengine_studio_124 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_tint'] >
		,
		ReturnType< $bog_gamengine_node['tint'] >
	>
	type $bog_gamengine_text_font__size_bog_gamengine_studio_125 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_text_font['size'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_studio_126 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	type $bog_gamengine_atlas__sources_bog_gamengine_studio_127 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['font_sources'] >
		,
		ReturnType< $bog_gamengine_atlas['sources'] >
	>
	type $bog_gamengine_text__font_bog_gamengine_studio_128 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Font'] >
		,
		ReturnType< $bog_gamengine_text['font'] >
	>
	type $bog_gamengine_text__atlas_bog_gamengine_studio_129 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Font_atlas'] >
		,
		ReturnType< $bog_gamengine_text['atlas'] >
	>
	type $bog_gamengine_text__value_bog_gamengine_studio_130 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_title'] >
		,
		ReturnType< $bog_gamengine_text['value'] >
	>
	type $bog_gamengine_text__height_bog_gamengine_studio_131 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_text_height'] >
		,
		ReturnType< $bog_gamengine_text['height'] >
	>
	type $bog_gamengine_text__color_bog_gamengine_studio_132 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_tint'] >
		,
		ReturnType< $bog_gamengine_text['color'] >
	>
	type $bog_gamengine_text__pos_bog_gamengine_studio_133 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_text_pos'] >
		,
		ReturnType< $bog_gamengine_text['pos'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_studio_134 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Text_shader'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__atlas_bog_gamengine_studio_135 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Font_atlas'] >
		,
		ReturnType< $bog_gamengine_batch['atlas'] >
	>
	type $bog_gamengine_batch__source_bog_gamengine_studio_136 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['mate_pool'] >
		,
		ReturnType< $bog_gamengine_batch['source'] >
	>
	type $bog_gamengine_studio_assets__fallback_bog_gamengine_studio_137 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_studio_assets['fallback'] >
	>
	type $bog_gamengine_key__bind_bog_gamengine_studio_138 = $mol_type_enforce<
		({ 
			'left': readonly(any)[],
			'right': readonly(any)[],
			'up': readonly(any)[],
			'down': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_key['bind'] >
	>
	type $bog_gamengine_input__key_bog_gamengine_studio_139 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Key'] >
		,
		ReturnType< $bog_gamengine_input['key'] >
	>
	type $bog_gamengine_cam_flat__height_bog_gamengine_studio_140 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['height'] >
	>
	type $bog_gamengine_cam_flat__zoom_min_bog_gamengine_studio_141 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['zoom_min'] >
	>
	type $bog_gamengine_cam_flat__zoom_max_bog_gamengine_studio_142 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['zoom_max'] >
	>
	type $bog_gamengine_point__cam_bog_gamengine_studio_143 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Cam'] >
		,
		ReturnType< $bog_gamengine_point['cam'] >
	>
	type $bog_gamengine_point__width_bog_gamengine_studio_144 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['draw_width'] >
		,
		ReturnType< $bog_gamengine_point['width'] >
	>
	type $bog_gamengine_point__height_bog_gamengine_studio_145 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['draw_height'] >
		,
		ReturnType< $bog_gamengine_point['height'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_studio_146 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__scale_bog_gamengine_studio_147 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_scale'] >
		,
		ReturnType< $bog_gamengine_sprite['scale'] >
	>
	type $bog_gamengine_sprite__tint_bog_gamengine_studio_148 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_tint_x'] >
		,
		ReturnType< $bog_gamengine_sprite['tint'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_studio_149 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__scale_bog_gamengine_studio_150 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_scale'] >
		,
		ReturnType< $bog_gamengine_sprite['scale'] >
	>
	type $bog_gamengine_sprite__rot_bog_gamengine_studio_151 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_rot_y'] >
		,
		ReturnType< $bog_gamengine_sprite['rot'] >
	>
	type $bog_gamengine_sprite__tint_bog_gamengine_studio_152 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_tint_y'] >
		,
		ReturnType< $bog_gamengine_sprite['tint'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_studio_153 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__scale_bog_gamengine_studio_154 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_scale'] >
		,
		ReturnType< $bog_gamengine_sprite['scale'] >
	>
	type $bog_gamengine_sprite__tint_bog_gamengine_studio_155 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_tint_xy'] >
		,
		ReturnType< $bog_gamengine_sprite['tint'] >
	>
	type $bog_gamengine_node__tint_bog_gamengine_studio_156 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['gizmo_tint_xy'] >
		,
		ReturnType< $bog_gamengine_node['tint'] >
	>
	type $mol_switch__value_bog_gamengine_studio_157 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['tool_pick'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_gamengine_studio_158 = $mol_type_enforce<
		({ 
			'cell': string,
			'rect': string,
			'fill': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_check__Icon_bog_gamengine_studio_159 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['tile_icon'] >
		,
		ReturnType< $mol_check['Icon'] >
	>
	type $mol_check__title_bog_gamengine_studio_160 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['tile_title'] >
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_gamengine_studio_161 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['tile_selected'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_image__uri_bog_gamengine_studio_162 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['tile_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_check__title_bog_gamengine_studio_163 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['row_title'] >
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_gamengine_studio_164 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['row_selected'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__attr_bog_gamengine_studio_165 = $mol_type_enforce<
		({ 
			'bog_gamengine_studio_shared': ReturnType< $bog_gamengine_studio['row_shared'] >,
		})  & ReturnType< $mol_check['attr'] >
		,
		ReturnType< $mol_check['attr'] >
	>
	type $mol_check__title_bog_gamengine_studio_166 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['kit_title'] >
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_gamengine_studio_167 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['kit_selected'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__title_bog_gamengine_studio_168 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_gamengine_studio_169 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['armed'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_row__sub_bog_gamengine_studio_170 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_drag__transfer_bog_gamengine_studio_171 = $mol_type_enforce<
		({ 
			'text/plain': ReturnType< $bog_gamengine_studio['asset_uri'] >,
		})  & ReturnType< $mol_drag['transfer'] >
		,
		ReturnType< $mol_drag['transfer'] >
	>
	type $mol_drag__Sub_bog_gamengine_studio_172 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['Asset_row'] >
		,
		ReturnType< $mol_drag['Sub'] >
	>
	type $mol_image__uri_bog_gamengine_studio_173 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['asset_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_form_field__name_bog_gamengine_studio_174 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_gamengine_studio_175 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_form_field__name_bog_gamengine_studio_176 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['field_name'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bids_bog_gamengine_studio_177 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['field_bids'] >
		,
		ReturnType< $mol_form_field['bids'] >
	>
	type $mol_form_field__content_bog_gamengine_studio_178 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['field_content'] >
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_number__enabled_bog_gamengine_studio_179 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_number['enabled'] >
	>
	type $mol_number__precision_view_bog_gamengine_studio_180 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_view'] >
	>
	type $mol_number__precision_change_bog_gamengine_studio_181 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_number__value_bog_gamengine_studio_182 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['vec_value'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__enabled_bog_gamengine_studio_183 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_number['enabled'] >
	>
	type $mol_number__precision_view_bog_gamengine_studio_184 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_view'] >
	>
	type $mol_number__precision_change_bog_gamengine_studio_185 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_number__value_bog_gamengine_studio_186 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['num_value'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_check_box__enabled_bog_gamengine_studio_187 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_check_box__checked_bog_gamengine_studio_188 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['flag_value'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_string__enabled_bog_gamengine_studio_189 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_bog_gamengine_studio_190 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['text_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_select__enabled_bog_gamengine_studio_191 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__value_bog_gamengine_studio_192 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['text_value'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_gamengine_studio_193 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['frame_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_list__rows_bog_gamengine_studio_194 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['list_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_row__sub_bog_gamengine_studio_195 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['list_row'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_string__enabled_bog_gamengine_studio_196 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__hint_bog_gamengine_studio_197 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['list_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gamengine_studio_198 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['list_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_199 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_200 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_201 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['list_drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_gamengine_studio_202 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['editing'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__title_bog_gamengine_studio_203 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_gamengine_studio_204 = $mol_type_enforce<
		ReturnType< $bog_gamengine_studio['list_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $bog_gamengine_studio extends $mol_view {
		tool_drop( next?: any ): any
		Escape( ): $mol_hotkey
		key_drop( next?: any ): any
		Delete_key( ): $mol_hotkey
		key_undo( next?: any ): any
		Undo_key( ): $mol_hotkey
		key_redo( next?: any ): any
		Redo_key( ): $mol_hotkey
		tab( next?: string ): string
		Side_switch( ): $mol_switch
		tab_hidden_0( ): boolean
		node_rows( ): readonly(any)[]
		Nodes( ): $mol_list
		Tree( ): $mol_scroll
		tab_hidden_1( ): boolean
		asset_rows( ): readonly(any)[]
		Asset_list( ): $mol_list
		Assets_page( ): $mol_scroll
		tab_hidden_2( ): boolean
		tile_rows( ): readonly(any)[]
		Tile_list( ): $mol_list
		Tiles_page( ): $mol_scroll
		tab_hidden_3( ): boolean
		kit_rows( ): readonly(any)[]
		Kit_list( ): $mol_list
		Kit_page( ): $mol_scroll
		Side( ): $mol_view
		grid( next?: boolean ): boolean
		Grid( ): $mol_check_box
		can_undo( ): boolean
		undo( next?: any ): any
		Undo( ): $mol_button_minor
		can_redo( ): boolean
		redo( next?: any ): any
		Redo( ): $mol_button_minor
		fit( next?: any ): any
		Fit( ): $mol_button_minor
		editing( ): boolean
		play( next?: any ): any
		Play( ): $mol_button_minor
		playing( ): boolean
		paused( next?: boolean ): boolean
		Pause( ): $mol_check_box
		stop( next?: any ): any
		Stop( ): $mol_button_minor
		placing( ): boolean
		asset_drop( next?: any ): any
		draw_width( ): ReturnType< ReturnType< $bog_gamengine_studio['Draw'] >['width'] >
		draw_height( ): ReturnType< ReturnType< $bog_gamengine_studio['Draw'] >['height'] >
		pointer_down( next?: any ): any
		pointer_move( next?: any ): any
		pointer_up( next?: any ): any
		wheel( next?: any ): any
		Draw( ): $bog_gamengine_draw
		Drop( ): $mol_drop
		scene_status( ): any
		Status( ): $mol_status
		live_stat( ): string
		Live( ): $mol_view
		canvas_foot( ): readonly(any)[]
		Canvas( ): $mol_page
		fields( ): readonly(any)[]
		detach( next?: any ): any
		Detach( ): $mol_button_minor
		node_dup( next?: any ): any
		Node_dup( ): $mol_button_minor
		node_drop( next?: any ): any
		Node_drop( ): $mol_button_minor
		form_foot( ): readonly(any)[]
		Form( ): $mol_form
		Inspect( ): $mol_page
		source_uri( ): string
		Save( ): $mol_link
		Klass( ): $mol_string
		module_tree_uri( ): string
		module_tree_name( ): string
		Export_tree( ): $mol_link
		module_ts_uri( ): string
		module_ts_name( ): string
		Export_ts( ): $mol_link
		Editor( ): $mol_textarea
		Aim( ): $mol_view
		kept_stat( ): string
		Kept( ): $mol_view
		undo_stat( ): string
		Undo_stat( ): $mol_view
		Source( ): $mol_page
		doc_land( ): any
		scene_input( ): any
		overlay_batches( ): readonly(any)[]
		clock_paused( ): boolean
		Clock( ): $bog_gamengine_clock
		Scene( ): ReturnType< ReturnType< $bog_gamengine_studio['Doc'] >['scene'] >
		Gizmo_shader( ): $bog_gamengine_shader_flat
		Gizmo_arrow( ): $bog_gamengine_shape_lines
		gizmo_arrow_nodes( ): readonly(any)[]
		Gizmo_box( ): $bog_gamengine_shape_lines
		gizmo_box_nodes( ): readonly(any)[]
		Rect_shape( ): $bog_gamengine_shape_lines
		rect_nodes( ): readonly(any)[]
		mate_name( ): string
		mate_nodes( ): readonly(any)[]
		mate_pos( id: any): Float32Array
		mate_scale( ): Float32Array
		mate_tint( id: any): Float32Array
		font_sources( ): readonly(any)[]
		mate_title( id: any): string
		mate_text_height( ): number
		mate_text_pos( id: any): Float32Array
		mate_pool( id: any): any
		gizmo_pos( ): Float32Array
		gizmo_scale( ): Float32Array
		gizmo_tint_x( ): Float32Array
		gizmo_rot_y( ): Float32Array
		gizmo_tint_y( ): Float32Array
		gizmo_tint_xy( ): Float32Array
		tool_pick( next?: string ): string
		tile_icon( id: any): any
		tile_title( id: any): string
		tile_selected( id: any, next?: boolean ): boolean
		tile_uri( id: any): string
		row_title( id: any): string
		row_selected( id: any, next?: boolean ): boolean
		row_shared( id: any): boolean
		kit_title( id: any): string
		kit_selected( id: any, next?: boolean ): boolean
		armed( id: any, next?: boolean ): boolean
		refs_names( id: any): string
		Refs_names( id: any): $mol_view
		Refs_aim( id: any): $mol_check
		refs_clear( id: any, next?: any ): any
		Refs_clear( id: any): $mol_button_minor
		asset_uri( id: any): string
		asset_icon( id: any): any
		asset_file( id: any): string
		asset_selected( id: any, next?: boolean ): boolean
		Asset_row( id: any): $mol_check
		node_hint( ): string
		node_name( next?: string ): string
		Name_string( ): $mol_string
		field_name( id: any): string
		field_bids( id: any): readonly(string)[]
		field_content( id: any): readonly(any)[]
		vec_value( id: any, next?: number ): number
		num_value( id: any, next?: number ): number
		flag_value( id: any, next?: boolean ): boolean
		text_value( id: any, next?: string ): string
		frame_options( ): readonly(string)[]
		list_rows( id: any): readonly(any)[]
		list_row( id: any): readonly(any)[]
		list_hint( id: any): string
		list_value( id: any, next?: string ): string
		list_drop( id: any, next?: any ): any
		list_add( id: any, next?: any ): any
		title( ): string
		selected( next?: any ): any
		source( next?: string ): string
		source_own( next?: string ): string
		klass( next?: string ): string
		land_link( next?: string ): string
		plugins( ): readonly(any)[]
		sub( ): readonly(any)[]
		Doc( ): $bog_gamengine_studio_doc
		Gizmo_arrows( ): $bog_gamengine_batch
		Gizmo_boxes( ): $bog_gamengine_batch
		Rect_lines( ): $bog_gamengine_batch
		Land( ): $bog_gamengine_studio_doc_land
		Mate_shape( ): $bog_gamengine_shape_lines
		Mate_lines( ): $bog_gamengine_batch
		Mate( id: any): $bog_gamengine_node
		Font( ): $bog_gamengine_text_font
		Font_atlas( ): $bog_gamengine_atlas
		Text_shader( ): $bog_gamengine_shader_sprite
		Mate_text( id: any): $bog_gamengine_text
		Mate_text_batch( id: any): $bog_gamengine_batch
		Assets( ): $bog_gamengine_studio_assets
		Key( ): $bog_gamengine_key
		Input( ): $bog_gamengine_input
		Cam( ): $bog_gamengine_cam_flat
		Point( ): $bog_gamengine_point
		Gizmo_x( ): $bog_gamengine_sprite
		Gizmo_y( ): $bog_gamengine_sprite
		Gizmo_xy( ): $bog_gamengine_sprite
		Rect_node( ): $bog_gamengine_node
		Tools( ): $mol_switch
		Tile( id: any): $mol_check
		Tile_image( id: any): $mol_image
		Row( id: any): $mol_check
		Kit( ): $bog_gamengine_studio_kit
		Kit_row( id: any): $mol_check
		Aim_at( id: any): $mol_check
		Refs( id: any): $mol_row
		Asset( id: any): $mol_drag
		Asset_image( id: any): $mol_image
		Asset_model( id: any): $mol_icon_cube
		Asset_sound( id: any): $mol_icon_music
		field_bid_lead( ): string
		field_bid_words( ): readonly(any)[]
		Name_field( ): $mol_form_field
		Field( id: any): $mol_form_field
		Vec_num( id: any): $mol_number
		Num( id: any): $mol_number
		Flag( id: any): $mol_check_box
		Text( id: any): $mol_string
		Frame( id: any): $mol_select
		List( id: any): $mol_list
		List_row( id: any): $mol_row
		List_field( id: any): $mol_string
		List_drop( id: any): $mol_button_minor
		List_add( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=studio.view.tree.d.ts.map